

// Material Kit 2 PRO React pages
import SignUpCover from "pages/Authentication/SignUp/Cover";

export default function SignUpCoverPage() {
  return <SignUpCover />;
}
